import { VisitorGroupType } from 'utils/VisitorGroup/VisitorGroup';
import { generateMockVisitorGroup } from './visitorGroup';

export const mockVisitorGroupInstallers = generateMockVisitorGroup({
  id: 'mockedIdInstallers',
  name: 'installers',
  type: VisitorGroupType.Installers
});
export const mockVisitorGroupCleaners = generateMockVisitorGroup({ id: 'mockedIdCleaners', name: 'cleaners' });
export const mockVisitorGroupCognitoTeam = generateMockVisitorGroup({
  id: 'mockedIdCognitoTeam',
  name: 'cognito team'
});
export const mockVisitorGroupInternalTeam = generateMockVisitorGroup({
  id: 'mockedIdInternalTeam',
  name: 'internal team'
});
export const mockVisitorGroupKeySharingUsers = generateMockVisitorGroup({
  id: 'mockedIdKeySharingUsers',
  name: 'key sharing users'
});
export const mockVisitorGroupEntraTeam = generateMockVisitorGroup({ id: 'mockedIdEntraTeam', name: 'entra team' });
export const mockVisitorGroupCardHolders = generateMockVisitorGroup({
  id: 'mockedIdCardHolders',
  name: 'card holders'
});
export const mockVisitorGroupCoContractors = generateMockVisitorGroup({
  id: 'mockedIdCo-contractors',
  name: 'co-contractors'
});

export const mockVisitorGroupAlpha = generateMockVisitorGroup({ id: 'mockGroupAlpha', name: 'Alpha Team' });
export const mockVisitorGroupBeta = generateMockVisitorGroup({ id: 'mockGroupBeta', name: 'Beta Squad' });
export const mockVisitorGroupGamma = generateMockVisitorGroup({ id: 'mockGroupGamma', name: 'Gamma Force' });
export const mockVisitorGroupDelta = generateMockVisitorGroup({ id: 'mockGroupDelta', name: 'Delta Crew' });
export const mockVisitorGroupEpsilon = generateMockVisitorGroup({ id: 'mockGroupEpsilon', name: 'Epsilon Unit' });
export const mockVisitorGroupZeta = generateMockVisitorGroup({ id: 'mockGroupZeta', name: 'Zeta Group' });
export const mockVisitorGroupEta = generateMockVisitorGroup({ id: 'mockGroupEta', name: 'Eta Division' });
export const mockVisitorGroupTheta = generateMockVisitorGroup({ id: 'mockGroupTheta', name: 'Theta Corp' });
export const mockVisitorGroupIota = generateMockVisitorGroup({ id: 'mockGroupIota', name: 'Iota Team' });
export const mockVisitorGroupKappa = generateMockVisitorGroup({ id: 'mockGroupKappa', name: 'Kappa Squad' });
export const mockVisitorGroupLambda = generateMockVisitorGroup({ id: 'mockGroupLambda', name: 'Lambda Force' });
export const mockVisitorGroupMu = generateMockVisitorGroup({ id: 'mockGroupMu', name: 'Mu Collective' });
export const mockVisitorGroupNu = generateMockVisitorGroup({ id: 'mockGroupNu', name: 'Nu Alliance' });
export const mockVisitorGroupXi = generateMockVisitorGroup({ id: 'mockGroupXi', name: 'Xi Brigade' });
export const mockVisitorGroupOmicron = generateMockVisitorGroup({ id: 'mockGroupOmicron', name: 'Omicron Labs' });

// Visitors created without an explicit `visitorGroupMembership` fall back to this default
// (see generateMockVisitor / generateMockVisitorGroupMembership) — it must be included below too.
export const mockVisitorGroupDefault = generateMockVisitorGroup({});

// Must include every group referenced by any visitor's visitorGroupMembership in visitorFixtures.ts —
// this backs the "all groups" warmup query that fills in the `name` field in the Apollo cache for the
// composed cache-only visitors query. A group missing here resolves with `name: undefined` at runtime.
export const mockVisitorGroupsInstallersAndCleaners = [
  mockVisitorGroupInstallers,
  mockVisitorGroupCleaners,
  mockVisitorGroupCoContractors,
  mockVisitorGroupCognitoTeam,
  mockVisitorGroupInternalTeam,
  mockVisitorGroupKeySharingUsers,
  mockVisitorGroupEntraTeam,
  mockVisitorGroupCardHolders,
  mockVisitorGroupAlpha,
  mockVisitorGroupBeta,
  mockVisitorGroupGamma,
  mockVisitorGroupDelta,
  mockVisitorGroupEpsilon,
  mockVisitorGroupZeta,
  mockVisitorGroupEta,
  mockVisitorGroupTheta,
  mockVisitorGroupIota,
  mockVisitorGroupKappa,
  mockVisitorGroupLambda,
  mockVisitorGroupMu,
  mockVisitorGroupNu,
  mockVisitorGroupXi,
  mockVisitorGroupOmicron,
  mockVisitorGroupDefault
];
